import LikeTypesService from '../../api/services/likeTypesService';

const LOAD_LIKE_TYPES_REQUEST = 'dailymile/likeTypes/LOAD_LIKE_TYPES';
const LOAD_LIKE_TYPES_SUCCESS = 'dailymile/likeTypes/LOAD_LIKE_TYPES_SUCCESS';
const LOAD_LIKE_TYPES_FAIL = 'dailymile/likeTypes/LOAD_LIKE_TYPES_FAIL';

const initialState = {
  loaded: false
};

const handlers = {
  [LOAD_LIKE_TYPES_REQUEST]: (state, action) => {
    return {
      ...state,
      loading: true
    };
  },

  [LOAD_LIKE_TYPES_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: true,
      likeTypes: action.payload.result
    };
  },

  [LOAD_LIKE_TYPES_FAIL]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error: action.payload.message
    };
  }
};

export default function reducer(state = initialState, action = {}) {
  if (handlers[action.type]) {
    return handlers[action.type](state, action);
  }
  return state;
}

export function loadLikeTypes() {
  return {
    description: 'load like types', 
    types: [LOAD_LIKE_TYPES_REQUEST, LOAD_LIKE_TYPES_SUCCESS, LOAD_LIKE_TYPES_FAIL],
    promise: () => LikeTypesService.getLikeTypes()
  };
}


// WEBPACK FOOTER //
// ./src/redux/modules/likeTypes.js